import { Button, Grid } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";

// import axios from 'axios';
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Modal from "@mui/material/Modal";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";

import { useTheme, useMediaQuery } from "@mui/material";

import AppBar from "@mui/material/AppBar";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import Slider from "@mui/material/Slider";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Link,
  useNavigate,
  useParams,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import usercalls from "../../Axios";
import consts from "../../constant";
import Context from "../../Context";
import { toast, ToastContainer } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  // border: "2px solid #000",
  p: 4,
  borderRadius: "10px",
};

function valuetext(value) {
  return `${value}%`;
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: "1px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TradeRight({ classic, fullScreen }) {
  const theme = useTheme();

  const { pathname } = useLocation();

  const {
    selcOrderBook,
    balanceUpdate,
    getHistory,
    setSelcOrderBook,
    setBalance,
    markPrice,
    setPointFilter,
    setBasePrecision,
    setQuotePrecision,
    pointFilter,
    quotePrecision,
    basePrecision,
    triggerPrice,
    balance,
    futurePrices,
  } = useContext(Context);

  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [orderValue, setOrderValue] = useState("");
  const [stopPrice, setStopPrice] = useState("");
  const [screen, setScreen] = useState("");
  const [sliderValue, setSliderValue] = useState(0);

  const [futurePrice, setFuturePrice] = useState("");
  const [futureQuantity, setFutureQuantity] = useState("");

  const [secondBalance, setSecondBalance] = useState(0);
  const [firstBalance, setFirstBalance] = useState(0);

  const [multiplier, setMultiplier] = useState(0);
  const [multiplierError, setMultiplierError] = useState("");

  function truncateToDecimals(num, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.floor(num * factor) / factor;
  }

  useEffect(() => {
    if (selcOrderBook?.length == 5) {
      setFuturePrice(Number(selcOrderBook[0])?.toFixed(4));
      setPrice(Number(selcOrderBook[0])?.toFixed(pointFilter));
      setQuantity(Number(selcOrderBook[1])?.toFixed(basePrecision));
      setOrderValue(
        (Number(selcOrderBook[0]) * Number(selcOrderBook[1])).toFixed(
          pointFilter
        )
      );
    } else if (selcOrderBook?.length == 1) {
      setFuturePrice("");
      setPrice("");
      setQuantity("");
      setOrderValue("");
    }

    return () => {
      setSelcOrderBook("");
    };
  }, [selcOrderBook]);

  useEffect(() => {
    if (futurePrices) {
      setFuturePrice(Number(futurePrices));
      setPrice(Number(futurePrices));
    }
  }, [futurePrices]);

  const calcFees = async () => {
    try {
      if (orderValue) {
        // console.log(
        //   orderValue,
        //   feesDetials,
        //   kucoinFeeDetails,
        //   value4,
        //   "orderValue"
        // );
        var originalValue = Number(orderValue);

        var kucoinFee = 0;

        if (value4 == 1) {
        } else {
          kucoinFee = Number(kucoinFeeDetails?.makerFeeRate) * orderValue;
        }
        // console.log(kucoinFee, "kucoinFee");
      } else {
        setFees(0);
      }
    } catch (error) {
      console.log("🚀 ~ calcFees ~ error:", error);
    }
  };

  // useEffect(() => {
  //   // calcFees()
  // }, [orderValue])

  const priceChange = async (pri, qua) => {
    // console.log(pointFilter, "pointFilter")
    if (pri && quantity) {
      setOrderValue((pri * quantity)?.toFixed(pointFilter));
    } else if (qua && price) {
      setOrderValue((qua * price)?.toFixed(pointFilter));
    } else {
      setOrderValue("");
    }
  };

  useEffect(() => {
    if (triggerPrice != 0) {
      setPrice(markPrice);
    }
  }, [triggerPrice]);

  const priceChangeSlider = async (val, crtval, type) => {
    // console.log(
    //   price,
    //   quantity,
    //   price * quantity,
    //   placeRoute,
    //   "chsdfiuasfdiasdf"
    // );

    // console.log(secondBalance);
    if (placeRoute == "future") {
      var costOfOneTradingUnit = 0;
      const currentMarkPrice = markPrice;
      // console.log(
      //   "🚀 ~ priceChangeSlider ~ price:",
      //   futurePrice,
      //   markPrice,
      //   multiplier
      // );
      if (value4 == 0) {
        costOfOneTradingUnit = futurePrice * multiplier;
        // console.log(
        //   "🚀 ~ priceChangeSlider ~ costOfOneTradingUnit:",
        //   costOfOneTradingUnit
        // );
      } else {
        // console.log(
        //   "🚀 ~ priceChangeSlider ~ currentMarkPrice:",
        //   currentMarkPrice
        // );
        costOfOneTradingUnit = currentMarkPrice * multiplier;
      }
      // console.log(
      //   value4,
      //   costOfOneTradingUnit,
      //   multiplier,
      //   "priceChangeSlider value4"
      // );
      const bal = secondBalance * leverage - secondBalance;
      // console.log("🚀 ~ priceChangeSlider ~ bal:", bal);
      const maxNotionalCapacity = (bal * val) / 100;
      // console.log(
      //   "🚀 ~ priceChangeSlider ~ maxNotionalCapacity:",
      //   maxNotionalCapacity
      // );
      let numberOfTradingUnits = 0; // Initialize the count for number of 'trading units'

      // Check for valid inputs to prevent division by zero or negative results
      if (costOfOneTradingUnit > 0 && maxNotionalCapacity >= 0) {
        // Math.floor() gives you the largest whole number of 'trading units'
        // that fits within maxNotionalCapacity
        numberOfTradingUnits = Math.floor(
          maxNotionalCapacity / costOfOneTradingUnit
        );
      }
      // console.log(
      //   "🚀 ~ priceChangeSlider ~ numberOfTradingUnits:",
      //   numberOfTradingUnits
      // );

      // Ensure the number of units is not negative
      const safeNumberOfTradingUnits = Math.max(0, numberOfTradingUnits);
      // console.log(
      //   "🚀 ~ priceChangeSlider ~ safeNumberOfTradingUnits:",
      //   safeNumberOfTradingUnits
      // );
      // console.log(markPrice, numberOfTradingUnits, "jsonjson");

      // --- THIS IS THE CRUCIAL CHANGE ---
      // Multiply the number of trading units by your original Multiplier
      // to get the total quantity in the base asset (e.g., total XRP)
      const multiples = safeNumberOfTradingUnits * multiplier;
      // console.log("🚀 ~ priceChangeSlider ~ multiples:", multiples);
      const finalFutureQuantity =
        value4 === 0
          ? multiples
          : Number(multiples * currentMarkPrice)?.toFixed(4);
      // console.log(
      //   "🚀 ~ priceChangeSlider ~ finalFutureQuantity:",
      //   finalFutureQuantity
      // );

      // --- Set the State with the Correct Final Quantity ---
      setFutureQuantity(finalFutureQuantity);
      openCostCalculation("", finalFutureQuantity);
      marketOpenCostCalculation(finalFutureQuantity);
    } else if (type == "BUY") {
      var bal =
        valueTab3 == 1 && (marginMode == "Normal" || marginMode == "Repay")
          ? userBalance?.second?.margin_balance
          : secondBalance;
      // userBalance?.second != null ? userBalance?.second?.spot_balance : 0;

      if (val != "" && bal > 0 && price && (value4 == 0 || value4 == 2)) {
        // console.log("🚀 ~ priceChangeSlider ~ bal:", bal);
        var ordval = bal * (val / 100);
        var kucoinFee = 0;
        var ownFee = 0;
        if (value4 == 0 || value4 == 2) {
          if (kucoinFeeDetails?.makerFeeRate) {
            kucoinFee = Number(kucoinFeeDetails?.makerFeeRate) * ordval;
          }
        } else {
          if (kucoinFeeDetails?.takerFeeRate) {
            kucoinFee = Number(kucoinFeeDetails?.takerFeeRate) * ordval;
          }
        }
        if (feesDetials?.buy_trade_commission) {
          if (feesDetials?.buy_trade_commission_type == "percentage") {
            ownFee = (Number(feesDetials?.buy_trade_commission) * ordval) / 100;
          } else {
            ownFee = Number(feesDetials?.buy_trade_commission);
          }
        }

        // console.log(
        //   "🚀 ~ priceChangeSlider ~ kucoinFee makerFeeRate:",
        //   kucoinFee,
        //   ownFee
        // );

        ordval = ordval - kucoinFee - ownFee;
        console.log("🚀 ~ priceChangeSlider ~ ordval:", ordval);

        setOrderValue(truncateToDecimals(Number(ordval), pointFilter));
        setQuantity(truncateToDecimals(Number(ordval) / price, basePrecision));
      } else if (
        val == "" &&
        crtval > 0 &&
        bal > 0 &&
        price &&
        (value4 == 0 || value4 == 2)
      ) {
        // console.log("🚀 ~ priceChangeSlider ~ crtval:", crtval);
        setOrderValue(Number(crtval));
        setQuantity(
          truncateToDecimals(Number(crtval) / price)?.toFixed(basePrecision)
        );
      } else if (value4 == 1 && val == "") {
        // console.log("🚀 ~ priceChangeSlider ~ crtval1:", crtval);
        setOrderValue(Number(crtval));
      } else if (val != "" && bal > 0 && value4 == 1) {
        // console.log("🚀 ~ priceChangeSlider ~ crtval2:", crtval);
        var ordval = bal * (val / 100);
        var kucoinFee = 0;
        var ownFee = 0;
        if (value4 == 0 || value4 == 2) {
          if (kucoinFeeDetails?.makerFeeRate) {
            kucoinFee = Number(kucoinFeeDetails?.makerFeeRate) * ordval;
          }
        } else {
          if (kucoinFeeDetails?.takerFeeRate) {
            kucoinFee = Number(kucoinFeeDetails?.takerFeeRate) * ordval;
          }
        }
        if (feesDetials?.buy_trade_commission) {
          if (feesDetials?.buy_trade_commission_type == "percentage") {
            ownFee = (Number(feesDetials?.buy_trade_commission) * ordval) / 100;
          } else {
            ownFee = Number(feesDetials?.buy_trade_commission);
          }
        }

        // console.log(
        //   "🚀 ~ priceChangeSlider ~ kucoinFee makerFeeRate:",
        //   kucoinFee,
        //   ownFee
        // );

        ordval = ordval - kucoinFee - ownFee;
        setOrderValue(truncateToDecimals(Number(ordval), quotePrecision));
      } else {
        setOrderValue("");
        setQuantity("");
      }
    } else {
      var bal =
        valueTab3 == 1 && value3 == 1 && marginMode != "Borrow"
          ? userBalance?.first?.margin_balance
          : firstBalance;
      // userBalance?.first != null ? userBalance?.first?.spot_balance : 0;

      if (val != "" && bal > 0 && price) {
        var ordval = bal * (val / 100);
        setQuantity(truncateToDecimals(Number(ordval), basePrecision));
        setOrderValue(truncateToDecimals(Number(ordval) * price, pointFilter));
      } else if (val == "" && crtval > 0 && bal > 0 && price) {
        setQuantity(Number(crtval));
        setOrderValue(truncateToDecimals(Number(crtval) * price, pointFilter));
      } else if (value4 == 1 && val == "") {
        setOrderValue(Number(crtval));
      } else if (val != "" && bal > 0 && value4 == 1) {
        var ordval = bal * (val / 100);
        setOrderValue(truncateToDecimals(Number(ordval), quotePrecision));
      } else {
        setOrderValue("");
        setQuantity("");
      }
    }
  };

  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));

  const [value2, setValue2] = useState(0);

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  const path = usercalls();

  const { id } = useParams();

  const token = window.localStorage.getItem("Rikosta");

  const [userBalance, setUserBalance] = useState({});

  const [value3, setValue3] = useState(0);

  const handleChange3 = (event, newValue) => {
    setValue3(newValue);
  };

  const [value4, setValue4] = useState(0);

  const handleChange4 = (event, newValue) => {
    setValue4(newValue);
    setFuturePrice("");
    setFutureQuantity("");
  };

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open, val) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setValue3(val);

    setState({ ...state, [anchor]: open });
  };

  const [valueTab3, setValueTab3] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();

  const type = searchParams.get("type");

  useEffect(() => {
    if (type == "spot") {
      setValueTab3(0);
    } else if (type == "cross") {
      setValueTab3(1);
    } else if (type == "isolated") {
      setValueTab3(2);
    } else if (!pathname?.includes("future")) {
      setValueTab3(0);
      searchParams.set("type", "spot");
      setSearchParams(searchParams);
    } else {
      setValueTab3(0);
      searchParams.delete("type");
      setSearchParams(searchParams);
    }
  }, [type]);

  const handleChangeTab3 = (event, newValue) => {
    // console.log(newValue, "newValue")
    setMarginMode("Normal");
    setValue3(0);
    setValue4(0);
    if (newValue == 0) {
      if (pathname?.includes("future")) {
        searchParams.delete("type");
        setSearchParams(searchParams);
      } else {
        searchParams.set("type", "spot");
        setSearchParams(searchParams);
      }
      setValueTab3(newValue);
    } else if (newValue == 1) {
      searchParams.set("type", "cross");
      setSearchParams(searchParams);
      setValueTab3(newValue);
    } else if (newValue == 2) {
      searchParams.set("type", "isolated");
      setSearchParams(searchParams);
      setValueTab3(newValue);
    }
  };
  const navigate = useNavigate();
  const [marginMode, setMarginMode] = useState("Normal");
  const [crossLev, setCrossLev] = useState(1);
  const [tempLev, setTempLev] = useState(1);

  const [statusLoad, setStatusLoad] = useState(false);

  const [maxLeverage, setMaxLeverage] = useState(50);
  const [leverage, setLeverage] = useState(0);

  const [openLongCost, setOpenLongCost] = useState(0);
  const [openShortCost, setOpenShortCost] = useState(0);

  const [marketOpenLongCost, setMarketOpenLongCost] = useState(0);
  const [marketOpenShortCost, setMarketOpenShortCost] = useState(0);

  const [maxMarginFirst, setMaxMarginFirst] = useState(0);
  const [maxMarginSecond, setMaxMarginSecond] = useState(0);

  const loaction = useLocation();
  const placeRoute = loaction.pathname?.split("/")[1];

  const [fees, setFees] = useState(0);

  const [feesDetials, setFeesDetails] = useState({});

  const [kucoinFeeDetails, setKucoinFeeDetails] = useState({});

  useEffect(() => {
    setPrice("");
    setQuantity("");
    setOrderValue("");
    setStopPrice("");
    setSliderValue(0);
    // setValue3(0);
  }, [valueTab3, value3, value4, marginMode, id]);

  const openCostCalculation = async (price, quantity) => {
    if (price && futureQuantity) {
      // console.log(price, futureQuantity, leverage, markPrice, "Tradsefsiufdhsduifhui")
      var positionNotional = price * futureQuantity;
      const initialMargin = positionNotional / leverage;

      const openLossCost =
        Math.floor(futureQuantity) *
        Math.abs(Math.min(0, 1 * (markPrice - price)));

      // Step 3: Calculate Cost Required to Open Short Position
      const totalCostCost = initialMargin + openLossCost;

      setOpenLongCost(totalCostCost.toFixed(2));

      const direction = -1; // -1 for short orders
      const openLoss =
        Math.floor(futureQuantity) *
        Math.abs(Math.min(0, direction * (markPrice - price)));

      // Step 3: Calculate Cost Required to Open Short Position
      const totalCost = initialMargin + openLoss;
      setOpenShortCost(totalCost?.toFixed(2));
    } else if (futurePrice && quantity) {
      // console.log(futurePrice, quantity, leverage, "Tradsefsiufdhsduifhui")
      var positionNotional = futurePrice * quantity;
      const initialMargin = positionNotional / leverage;

      const openLossCost =
        Math.floor(quantity) *
        Math.abs(Math.min(0, 1 * (markPrice - futurePrice)));

      // Step 3: Calculate Cost Required to Open Short Position
      const totalCostCost = initialMargin + openLossCost;
      setOpenLongCost(totalCostCost?.toFixed(2));

      const direction = -1; // -1 for short orders
      const openLoss =
        Math.floor(quantity) *
        Math.abs(Math.min(0, direction * (markPrice - futurePrice)));

      // Step 3: Calculate Cost Required to Open Short Position
      const totalCost = initialMargin + openLoss;
      setOpenShortCost(totalCost?.toFixed(2));
    } else if (futurePrice && futureQuantity) {
      // console.log(futurePrice, quantity, leverage, "Tradsefsiufdhsduifhui")
      var positionNotional = futurePrice * futureQuantity;
      const initialMargin = positionNotional / leverage;
      const openLossCost =
        Math.floor(futureQuantity) *
        Math.abs(Math.min(0, 1 * (markPrice - futurePrice)));

      // Step 3: Calculate Cost Required to Open Short Position
      const totalCostCost = initialMargin + openLossCost;

      setOpenLongCost(totalCostCost?.toFixed(2));

      const direction = -1; // -1 for short orders
      const openLoss =
        Math.floor(futureQuantity) *
        Math.abs(Math.min(0, direction * (markPrice - futurePrice)));

      // Step 3: Calculate Cost Required to Open Short Position
      const totalCost = initialMargin + openLoss;
      setOpenShortCost(totalCost?.toFixed(2));
    } else {
      setOpenLongCost(0);
      setOpenShortCost(0);
    }
  };

  const marketOpenCostCalculation = (qty) => {
    const quantity = qty ? qty : futureQuantity;
    var positionNotional = markPrice * (quantity / markPrice);
    const initialMargin = positionNotional / leverage;

    const openLossCost =
      Math.floor(quantity) * Math.abs(Math.min(0, 1 * (markPrice - markPrice)));

    const totalCostCost = initialMargin + openLossCost;
    // console.log(totalCostCost, "totalCostCost");

    setMarketOpenLongCost(totalCostCost?.toFixed(2));

    const direction = -1; // -1 for short orders
    const openLoss =
      Math.floor(quantity) *
      Math.abs(Math.min(0, direction * (markPrice - markPrice)));

    // Step 3: Calculate Cost Required to Open Short Position
    const totalCost = initialMargin + openLoss;
    setMarketOpenShortCost(totalCost?.toFixed(2));
  };

  useEffect(() => {
    if (markPrice) {
      openCostCalculation();
      marketOpenCostCalculation();
    }
  }, [markPrice]);

  const placeOrderSubmit = async (type) => {
    try {
      var tradeType = searchParams.get("type");
      if (!price && value4 != 1) return toast.error("Please Enter Price");
      if (!quantity && value4 != 1) return toast.error("Please Enter Quantity");
      if (!orderValue) return toast.error("Please Enter Value");
      if (!stopPrice && value4 == 2)
        return toast.error("Please Enter Stop Price");
      // var Buybal = userBalance?.second != null ? userBalance?.second?.spot_balance : 0
      // var Sellbal = userBalance?.first != null ? userBalance?.first?.spot_balance : 0
      var Buybal = secondBalance;
      var Sellbal = firstBalance;
      console.log(
        Buybal,
        Sellbal,
        orderValue,
        quantity,
        balance,
        marginMode,
        "buy and sellk"
      );
      // if (type == "BUY" && Buybal == 0)
      //   return toast.error("Insufficient Balance");
      // if (type == "SELL" && Sellbal == 0)
      //   return toast.error("Insufficient Balance");

      if (marginMode == "Normal" && tradeType != "spot") {
        console.log(orderValue, "orderValue", balance?.second?.margin_balance);
        Buybal = balance?.second?.margin_balance;
        if (
          type == "BUY" &&
          Number(balance?.second?.margin_balance) < Number(orderValue)
        )
          return toast.error("Insufficient Balance");
        if (
          type == "SELL" &&
          Number(balance?.first?.margin_balance) < Number(quantity)
        )
          return toast.error("Insufficient Balance");
      } else if (marginMode == "Borrow" && tradeType != "spot") {
        Buybal = balance?.second?.margin_amount;
        if (
          type == "BUY" &&
          Number(balance?.second?.margin_amount) < Number(orderValue)
        )
          return toast.error("Insufficient Balance");
        if (
          type == "SELL" &&
          Number(balance?.first?.margin_amount) < Number(quantity)
        )
          return toast.error("Insufficient Balance");
      } else if (marginMode == "Repay" && tradeType != "spot") {
        Buybal = balance?.second?.margin_balance;
        if (
          type == "BUY" &&
          Number(balance?.second?.margin_balance) < Number(orderValue)
        )
          return toast.error("Insufficient Balance");
        if (
          type == "SELL" &&
          Number(balance?.first?.margin_balance) < Number(quantity)
        )
          return toast.error("Insufficient Balance");
      } else {
        console.log(
          Buybal,
          Sellbal,
          orderValue,
          quantity,
          balance,
          "buy and sellk"
        );
        if (type == "BUY" && Number(Buybal) < Number(orderValue))
          return toast.error("Insufficient Balance");
        if (type == "SELL" && Number(Sellbal) < Number(quantity))
          return toast.error("Insufficient Balance");
      }

      if (type == "BUY") {
        var kucoinFee = 0;
        var ownFee = 0;
        if (value4 == 0 || value4 == 2) {
          if (kucoinFeeDetails?.makerFeeRate) {
            kucoinFee = Number(kucoinFeeDetails?.makerFeeRate) * Buybal;
          }
        } else {
          if (kucoinFeeDetails?.takerFeeRate) {
            kucoinFee = Number(kucoinFeeDetails?.takerFeeRate) * Buybal;
          }
        }
        if (feesDetials?.buy_trade_commission) {
          if (feesDetials?.buy_trade_commission_type == "percentage") {
            ownFee = (Number(feesDetials?.buy_trade_commission) * Buybal) / 100;
          } else {
            ownFee = Number(feesDetials?.buy_trade_commission);
          }
        }

        Buybal = Buybal - kucoinFee - ownFee;
        var checkQuantity = truncateToDecimals(
          Number(Number(Buybal) / Number(price)),
          basePrecision
        );
        console.log(
          "🚀 ~ placeOrderSubmit ~ checkQuantity:",
          checkQuantity,
          quantity
        );
        // console.log(
        //   "🚀 ~ placeOrderSubmit ~ checkQuantity:",
        //   checkQuantity,
        //   value4,
        //   Number(Buybal)?.toFixed(quotePrecision),
        //   orderValue
        // );
        if (checkQuantity < quantity && (value4 == 0 || value4 == 2)) {
          return toast.error("Max quantity is " + checkQuantity);
        } else if (
          Number(Buybal)?.toFixed(quotePrecision) < orderValue &&
          value4 == 1
        ) {
          return toast.error(
            "Maxs quantity is " + Number(Buybal)?.toFixed(quotePrecision)
          );
        }
      }
      // console.log(kucoinFee, ownFee, "saudfhsuiadfh");

      setStatusLoad(true);
      const url =
        tradeType === "spot"
          ? `${consts.BackendUrl}/kucoin/kucoinPlaceTrade`
          : `${consts.BackendUrl}/kucoin/kucoinMarginTrade`;
      const payload =
        tradeType === "spot"
          ? {
              price: price,
              quantity:
                value4 == 0 ? quantity : value4 == 1 ? orderValue : quantity,
              side: type == "BUY" ? "buy" : "sell",
              symbol: id,
              type:
                value4 == 0 ? "limit" : value4 == 1 ? "market" : "stop-limit",
              stop_price: stopPrice,
            }
          : {
              price: price,
              type:
                value4 === 0 ? "limit" : value4 === 1 ? "market" : "stop-limit",
              quantity:
                value4 == 0 ? quantity : value4 == 1 ? orderValue : quantity,
              symbol: id,
              side: type == "BUY" ? "buy" : "sell",
              tradeType: tradeType === "spot" ? "spot" : "margin",
              marginType: marginMode,
              marginAccount: tradeType === "spot" ? "" : "Cross",
              stop_price: stopPrice,
            };
      // console.log(payload, "payloads");
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        toast.success(result?.message || "Sucessfully Placed");
        getBalance(id);
        setQuantity("");
        setOrderValue("");
        setPrice("");
        setStopPrice("");
        getHistory(Math.random(6));
        setOpenLongCost(0);
        setOpenShortCost(0);
        setMarketOpenShortCost(0);
        setMarketOpenLongCost(0);
      } else {
        toast.error(result?.message);
        if (result?.message == "Please Verify KYC") {
          setTimeout(() => {
            navigate("/Kycverify");
          }, 1000);
        }
      }
      setStatusLoad(false);
    } catch (error) {
      console.log(error, "error");
      setStatusLoad(false);
    }
  };

  const PlaceFutureOrder = async (type, positionSide) => {
    try {
      if (!futurePrice && value4 != 1) return toast.error("Please Enter Price");
      if (!futureQuantity && value4 != 1)
        return toast.error("Please Enter Quantity");

      var payload = {
        symbol: id,
        side: type == "BUY" ? "buy" : "sell",
        positionSide: positionSide == "LONG" ? "long" : "short",
        type: value4 == 0 ? "limit" : "market",
        quantity: futureQuantity,
        price: Number(futurePrice),
        marginAccount: age == "cross" ? "Cross" : "Isolated",
        tradeType: "future",
      };
      // console.log("🚀 ~ PlaceFutureOrder ~ payload:", payload);

      setStatusLoad(true);

      const url = `${consts.BackendUrl}/kucoin/kucoinFutureTrade`;
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      console.log("🚀 ~ PlaceFutureOrder ~ result:", result);
      if (result?.success == true) {
        toast.success(result?.message);
        getBalance(id);
        setFuturePrice("");
        setFutureQuantity("");
        setSliderValue(0);
        getHistory(placeRoute, id);
      } else {
        toast.error(result?.message);
        if (result?.message == "Please Verify KYC") {
          setTimeout(() => {
            navigate("/Kycverify");
          }, 1000);
        }
      }
      setStatusLoad(false);
    } catch (error) {
      console.log(error, "error");
      setStatusLoad(false);
    }
  };

  const getLeverage = async () => {
    try {
      const url = `${consts.BackendUrl}/owntrade/getFutureLeverage`;
      var payload = {
        pair: id,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setLeverage(
          result?.result?.marginMode == "cross"
            ? result?.result?.cross_lever
            : result?.result?.isolated_lever
        );
        setLev(
          result?.result?.marginMode == "cross"
            ? result?.result?.cross_lever
            : result?.result?.isolated_lever
        );
        setMaxLeverage(100);
        setAge(result?.result?.marginMode);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const getMarginDetails = async () => {
    try {
      const url = `${consts.BackendUrl}/owntrade/getMarginDetails`;
      var payload = {
        pair: id,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setTempLev(result?.result[0]?.leverage);
        setCrossLev(result?.result[0]?.leverage);
        setMaxMarginFirst(result?.result[1]?.margin_amount);
        setMaxMarginSecond(result?.result[0]?.margin_amount);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const [position, setPosition] = useState("Open");

  const [lev, setLev] = useState(20);

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [age, setAge] = useState("cross");
  const handleChange = (event) => {
    changeMarginType(event.target.value);
    setAge(event.target.value);
  };

  // function calculateMaxLoan(balance, leverage) {
  //   const maxPosition = balance * leverage;
  //   const maxLoan = Math.floor(maxPosition - balance); // remove decimal
  //   return {
  //     maxPosition: maxPosition.toFixed(8),
  //     maxLoan
  //   };
  // }

  // // Example usage:
  // const balance = 19.99164701;
  // const leverage = 3;

  // const result = calculateMaxLoan(balance, leverage);
  // console.log("Max Loan:", result.maxLoan + balance);

  // price calculation
  // const amount = 29
  // const currentBalance = 19.99164701

  // const calcBal = () => {
  //   if (amount?.toFixed(1) > currentBalance) {
  //     if (amount > (currentBalance + 10)) {
  //       console.log(Math.floor(amount - Math.floor(currentBalance + 10) + 10))
  //     } else {
  //       console.log(10)
  //     }
  //   } else {
  //     console.log(0)
  //   }
  // }

  // calcBal()

  const formatWithPrecisionLimit = (value, precision) => {
    const [intPart, decimalPart] = value.toString().split(".");

    if (!decimalPart || decimalPart.length <= precision) {
      return parseFloat(value).toFixed(decimalPart?.length || 0);
    }

    return `${intPart}.${decimalPart.slice(0, precision)}`;
  };

  const limitBuy = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="display-1">
              <div className="aval aval-balance">Available balance</div>
              {type === "cross" && (
                <div
                  onClick={() => setOpen1(true)}
                  className="aval leaverage-tab cursor"
                >
                  {crossLev}x
                </div>
              )}
            </div>
            <div className="display-1 usd">
              {type === "spot" && (
                <div className="">
                  {" "}
                  {/* {userBalance?.second != null
                  ? Number(userBalance?.second?.spot_balance)?.toFixed(4)
                  : 0}{" "} */}
                  {secondBalance ? secondBalance : 0} {id?.split("_")[1]}
                </div>
              )}

              {type === "cross" &&
              (marginMode === "Normal" || marginMode === "Repay") ? (
                <div className="">
                  {" "}
                  {userBalance?.second?.margin_balance?.toFixed(8)
                    ? userBalance?.second?.margin_balance?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[1]}
                </div>
              ) : (
                type === "cross" &&
                marginMode === "Borrow" && (
                  <div className="">
                    {" "}
                    {secondBalance ? secondBalance : 0} {id?.split("_")[1]}
                  </div>
                )
              )}
            </div>
          </div>
          {/* <div className="trade-label">Order price</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field mt-5"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Order Price"
              type="number"
              value={price}
              onChange={(e) => {
                const input = e.target.value;

                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange(numericValue, "");
                  setPrice(numericValue);
                  if (numericValue) {
                    if (quantity) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(quantity || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          basePrecision
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Qty</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[0]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Quantity"
              type="number"
              value={quantity}
              onChange={(e) => {
                const input = e.target.value;
                // console.log(basePrecision, input, "basePrecision")
                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${basePrecision}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange("", numericValue);
                  setQuantity(numericValue);
                  if (numericValue) {
                    if (price) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(price || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Order value</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Order value"
              type="number"
              value={orderValue}
              onChange={(e) => {
                const input = e.target.value;
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);
                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  setOrderValue(numericValue);
                  // priceChangeSlider("", numericValue, "BUY");
                  if (numericValue) {
                    if (price) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(price || 1),
                          basePrecision
                        )
                      );
                    } else if (quantity) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(quantity || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setQuantity("");
                  }
                }
              }}
            />
          </FormControl>

          {/* <div class="mydict ">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
                setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "BUY");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div> */}
          <div className="display-2 flex-wrap">
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(25, "", "BUY")}
            >
              25%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(50, "", "BUY")}
            >
              50%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(75, "", "BUY")}
            >
              75%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(100, "", "BUY")}
            >
              100%
            </div>
          </div>

          {type != "spot" && marginMode == "Borrow" && (
            <>
              {/* <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2" >
                  <div>
                    Max
                  </div>
                  <div>
                    {firstBalance}  {id?.split("_")[1]}
                  </div>
                </div>
              </div> */}

              <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2">
                  <div>Borrowing</div>
                  <div>
                    {orderValue &&
                    orderValue > userBalance?.second?.margin_balance
                      ? Math.abs(
                          userBalance?.second?.margin_balance - orderValue
                        )?.toFixed(8)
                      : 0}{" "}
                    {id?.split("_")[1]}
                  </div>
                </div>
              </div>
            </>
          )}

          {type != "spot" && marginMode == "Repay" && (
            <>
              <div className="buy-btn mt-10 fnt-cost">
                {/* <div className="display-2" >
                  <div>
                    Repaying
                  </div>
                  <div>
                    0  {id?.split("_")[1]}
                  </div>
                </div> */}
                <div className="display-2 mt-5">
                  <div>Liabilities</div>
                  <div>
                    {userBalance?.first?.margin_debt_amount
                      ? Number(userBalance?.first?.margin_debt_amount)?.toFixed(
                          8
                        )
                      : 0}{" "}
                    {id?.split("_")[0]}
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="buy-btn mt-10">
            {token ? (
              <Button
                variant="contained"
                disabled={statusLoad}
                onClick={() => {
                  if (token) {
                    placeOrderSubmit("BUY");
                  }
                }}
              >
                Buy
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")}>
                {" "}
                Login / Sign Up
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const marketBuy = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="display-1">
              <div className="aval aval-balance">Available balance</div>
              {type === "cross" && (
                <div
                  onClick={() => setOpen1(true)}
                  className="aval leaverage-tab cursor"
                >
                  {crossLev}x
                </div>
              )}
            </div>
            <div className="display-1 usd">
              {type === "spot" && (
                <div className="">
                  {" "}
                  {/* {userBalance?.second != null
                  ? Number(userBalance?.second?.spot_balance)?.toFixed(4)
                  : 0}{" "} */}
                  {secondBalance ? secondBalance : 0} {id?.split("_")[1]}
                </div>
              )}

              {type === "cross" &&
              (marginMode === "Normal" || marginMode === "Repay") ? (
                <div className="">
                  {" "}
                  {Number(userBalance?.second?.margin_balance)
                    ? Number(userBalance?.second?.margin_balance)?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[1]}
                </div>
              ) : (
                type === "cross" &&
                marginMode === "Borrow" && (
                  <div className="">
                    {" "}
                    {secondBalance ? secondBalance : 0} {id?.split("_")[1]}
                  </div>
                )
              )}
            </div>
          </div>
          {/* <FormControl
            sx={{ width: "100%", marginTop: "8px" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment
                  position="end"
                  className="adroment"
                >
                  USDT
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Price"
              type="number"
            />
          </FormControl> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#F3F3F366", // your color here
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: "#FF5722",
                },
              }}
              placeholder="Market Best Price"
              type="number"
              disabled={true}
            />
          </FormControl>

          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Amount"
              type="number"
              value={orderValue}
              onChange={(e) => {
                const input = e.target.value;
                // console.log(input, quotePrecision, "inputinput")
                // Build dynamic regex for decimal places
                const regex = new RegExp(
                  `^\\d*(\\.\\d{0,${quotePrecision}})?$`
                );
                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // console.log(numericValue, "inputinput numericValue")
                  priceChangeSlider("", numericValue, "BUY");
                }
              }}
            />
          </FormControl>

          {/* <div class="mydict">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
              setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "BUY");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div> */}
          <div className="display-2 flex-wrap">
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(25, "", "BUY")}
            >
              25%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(50, "", "BUY")}
            >
              50%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(75, "", "BUY")}
            >
              75%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(100, "", "BUY")}
            >
              100%
            </div>
          </div>

          {type != "spot" && marginMode == "Borrow" && (
            <>
              {/* <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2" >
                  <div>
                    Max
                  </div>
                  <div>
                    {maxMarginFirst}  {id?.split("_")[1]}
                  </div>
                </div>
              </div> */}

              <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2">
                  <div>Borrowing</div>
                  <div>
                    {orderValue &&
                    orderValue > userBalance?.second?.margin_balance
                      ? Math.abs(
                          orderValue - userBalance?.second?.margin_balance
                        )?.toFixed(4)
                      : 0}{" "}
                    {id?.split("_")[1]}
                  </div>
                </div>
              </div>
            </>
          )}

          {type != "spot" && marginMode == "Repay" && (
            <>
              <div className="buy-btn mt-10 fnt-cost">
                {/* <div className="display-2">
                  <div>Repaying</div>
                  <div>0 {id?.split("_")[1]}</div>
                </div> */}
                <div className="display-2 mt-5">
                  <div>Liabilities</div>
                  {userBalance?.first?.margin_debt_amount
                    ? Number(userBalance?.first?.margin_debt_amount)?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[0]}
                </div>
              </div>
            </>
          )}
          <div className="buy-btn mt-10">
            {token ? (
              <Button
                variant="contained"
                disabled={statusLoad}
                onClick={() => {
                  if (token) {
                    placeOrderSubmit("BUY");
                  }
                }}
              >
                Buy
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")}>
                {" "}
                Login / Sign Up
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const limitSell = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="display-1">
              <div className="aval aval-balance">Available balance</div>
              {type === "cross" && (
                <div
                  onClick={() => setOpen1(true)}
                  className="aval leaverage-tab cursor"
                >
                  {crossLev}x
                </div>
              )}
            </div>
            <div className="display-1 usd">
              {type === "spot" && (
                <div className="">
                  {/* {userBalance?.first != null
                  ? Number(userBalance?.first?.margin_balance)?.toFixed(4)
                  : 0}{" "} */}
                  {firstBalance ? firstBalance : 0} {id?.split("_")[0]}
                </div>
              )}
              {type === "cross" &&
              (marginMode === "Normal" || marginMode === "Repay") ? (
                <div className="">
                  {" "}
                  {userBalance?.first?.margin_balance
                    ? userBalance?.first?.margin_balance?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[0]}
                </div>
              ) : (
                type === "cross" &&
                marginMode === "Borrow" && (
                  <div className="cross-sell-borrow">
                    {" "}
                    {firstBalance ? firstBalance : 0} {id?.split("_")[0]}
                  </div>
                )
              )}
            </div>
          </div>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field mt-5"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Order Price"
              type="number"
              value={price}
              onChange={(e) => {
                const input = e.target.value;
                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange(numericValue, "");
                  setPrice(numericValue);
                  if (numericValue) {
                    if (quantity) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(quantity || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          basePrecision
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[0]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Quantity"
              type="number"
              value={quantity}
              onChange={(e) => {
                const input = e.target.value;
                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${basePrecision}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange("", numericValue);
                  setQuantity(numericValue);
                  if (numericValue) {
                    if (price) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(price || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Order Value"
              type="number"
              value={orderValue}
              onChange={(e) => {
                const input = e.target.value;
                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChangeSlider("", numericValue, "BUY");
                  setOrderValue(numericValue);
                  if (numericValue) {
                    if (price) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(price || 1),
                          basePrecision
                        )
                      );
                    } else if (quantity) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(quantity || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setQuantity("");
                  }
                }
              }}
            />
          </FormControl>

          {/* <div class="mydict ">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
              setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "SELL");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div> */}
          <div className="display-2 flex-wrap">
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(25, "", "SELL")}
            >
              25%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(50, "", "SELL")}
            >
              50%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(75, "", "SELL")}
            >
              75%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(100, "", "SELL")}
            >
              100%
            </div>
          </div>
          {type != "spot" && marginMode == "Borrow" && (
            <>
              {/* <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2" >
                  <div>
                    Max
                  </div>
                  <div>
                    {secondBalance}  {id?.split("_")[1]}
                  </div>
                </div>
              </div> */}

              <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2">
                  <div>Borrowing</div>
                  <div>
                    {quantity && quantity > userBalance?.first?.margin_balance
                      ? Math.abs(
                          userBalance?.first?.margin_balance - quantity
                        )?.toFixed(8)
                      : 0}{" "}
                    {id?.split("_")[0]}
                  </div>
                </div>
              </div>
            </>
          )}

          {type != "spot" && marginMode == "Repay" && (
            <>
              <div className="buy-btn mt-10 fnt-cost">
                {/* <div className="display-2" >
                  <div>
                    Repaying
                  </div>
                  <div>
                    0  {id?.split("_")[1]}
                  </div>
                </div> */}
                <div className="display-2 mt-5">
                  <div>Liabilities</div>
                  <div>
                    {userBalance?.second?.margin_debt_amount
                      ? Number(
                          userBalance?.second?.margin_debt_amount
                        )?.toFixed(8)
                      : 0}{" "}
                    {id?.split("_")[1]}
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="sell-btn mt-10">
            {token ? (
              <Button
                variant="contained"
                disabled={statusLoad}
                onClick={() => {
                  if (token) {
                    placeOrderSubmit("SELL");
                  }
                }}
              >
                Sell
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")}>
                {" "}
                Login / Sign Up
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const marketSell = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="display-1">
              <div className="aval aval-balance">Available balance</div>
              {type === "cross" && (
                <div
                  onClick={() => setOpen1(true)}
                  className="aval leaverage-tab cursor"
                >
                  {crossLev}x
                </div>
              )}
            </div>
            <div className="display-1 usd">
              {type === "spot" && (
                <div className="">
                  {/* {userBalance?.first != null
                  ? Number(userBalance?.first?.spot_balance)?.toFixed(4)
                  : 0}{" "} */}
                  {firstBalance ? firstBalance : 0} {id?.split("_")[0]}
                </div>
              )}

              {type === "cross" &&
              (marginMode === "Normal" || marginMode === "Repay") ? (
                <div className="">
                  {" "}
                  {Number(userBalance?.first?.margin_balance)
                    ? Number(userBalance?.first?.margin_balance)?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[0]}
                </div>
              ) : (
                type === "cross" &&
                marginMode === "Borrow" && (
                  <div className="">
                    {" "}
                    {Number(
                      firstBalance ? Number(firstBalance)?.toFixed(8) : 0
                    )}{" "}
                    {id?.split("_")[0]}
                  </div>
                )
              )}
            </div>
          </div>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field mt-5"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Market Best Price"
              type="number"
              disabled={true}
            />
          </FormControl>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[0]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Amount"
              type="number"
              value={orderValue}
              onChange={(e) => {
                const input = e.target.value;

                // Build dynamic regex for decimal places
                const regex = new RegExp(
                  `^\\d*(\\.\\d{0,${quotePrecision}})?$`
                );

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  priceChangeSlider("", numericValue, "BUY");
                }
              }}
            />
          </FormControl>

          {/* <div class="mydict">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
              setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "SELL");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div> */}
          <div className="display-2 flex-wrap">
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(25, "", "SELL")}
            >
              25%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(50, "", "SELL")}
            >
              50%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(75, "", "SELL")}
            >
              75%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(100, "", "SELL")}
            >
              100%
            </div>
          </div>
          {type != "spot" && marginMode == "Borrow" && (
            <>
              {/* <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2" >
                  <div>
                    Max
                  </div>
                  <div>
                    {maxMarginFirst}  {id?.split("_")[1]}
                  </div>
                </div>
              </div> */}

              <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2">
                  <div>Borrowing</div>
                  <div>
                    {orderValue &&
                    orderValue > userBalance?.first?.margin_balance
                      ? Math.abs(
                          orderValue - userBalance?.first?.margin_balance
                        )?.toFixed(2)
                      : 0}{" "}
                    {id?.split("_")[0]}
                  </div>
                </div>
              </div>
            </>
          )}

          {type != "spot" && marginMode == "Repay" && (
            <>
              <div className="buy-btn mt-10 fnt-cost">
                {/* <div className="display-2">
                  <div>Repaying</div>
                  <div>0 {id?.split("_")[1]}</div>
                </div> */}
                <div className="display-2 mt-5">
                  <div>Liabilities</div>
                  {userBalance?.second?.margin_debt_amount
                    ? Number(userBalance?.second?.margin_debt_amount)?.toFixed(
                        8
                      )
                    : 0}{" "}
                  {id?.split("_")[1]}
                </div>
              </div>
            </>
          )}
          <div className="sell-btn mt-10">
            {token ? (
              <Button
                variant="contained"
                onClick={() => {
                  if (token) {
                    placeOrderSubmit("SELL");
                  }
                }}
              >
                Sell
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")}>
                {" "}
                Login / Sign Up
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const stopLimitBuy = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="display-1">
              <div className="aval aval-balance">Available balance</div>
              {type === "cross" && (
                <div
                  onClick={() => setOpen1(true)}
                  className="aval leaverage-tab cursor"
                >
                  {crossLev}x
                </div>
              )}
            </div>
            <div className="display-1 usd">
              {/* <div className=""> {userBalance?.second != null ? Number(userBalance?.second?.spot_balance)?.toFixed(4) : 0} {id?.split("_")[1]}</div> */}
              {type === "spot" && (
                <div className="">
                  {secondBalance ? secondBalance : 0} {id?.split("_")[1]}
                </div>
              )}

              {type === "cross" &&
              (marginMode === "Normal" || marginMode === "Repay") ? (
                <div className="">
                  {" "}
                  {Number(userBalance?.second?.margin_balance)
                    ? Number(userBalance?.second?.margin_balance)?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[1]}
                </div>
              ) : (
                type === "cross" &&
                marginMode === "Borrow" && (
                  <div className="">
                    {" "}
                    {secondBalance ? secondBalance : 0} {id?.split("_")[1]}
                  </div>
                )
              )}
            </div>
          </div>
          {/* <div className="trade-label">Order price</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field mt-5"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Stop"
              type="number"
              value={stopPrice}
              onChange={(e) => {
                const input = e.target.value;

                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  setStopPrice(numericValue);
                }
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Qty</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Price"
              type="number"
              value={price}
              onChange={(e) => {
                const input = e.target.value;

                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange(numericValue, "");
                  setPrice(numericValue);
                  if (numericValue) {
                    if (quantity) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(quantity || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          basePrecision
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Order value</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[0]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Amount"
              type="number"
              value={quantity}
              onChange={(e) => {
                const input = e.target.value;
                // console.log(basePrecision, input, "basePrecision")
                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${basePrecision}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange("", numericValue);
                  setQuantity(numericValue);
                  if (numericValue) {
                    if (price) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(price || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>

          {/* <div class="mydict">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
              setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "BUY");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div> */}
          <div className="display-2 flex-wrap">
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(25, "", "BUY")}
            >
              25%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(50, "", "BUY")}
            >
              50%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(75, "", "BUY")}
            >
              75%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(100, "", "BUY")}
            >
              100%
            </div>
          </div>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field mt-5"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Amount"
              type="number"
              value={orderValue}
              onChange={(e) => {
                const input = e.target.value;
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);
                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  setOrderValue(numericValue);
                  // priceChangeSlider("", numericValue, "BUY");
                  if (numericValue) {
                    if (price) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(price || 1),
                          basePrecision
                        )
                      );
                    } else if (quantity) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(quantity || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setQuantity("");
                  }
                }
              }}
            />
          </FormControl>

          {type != "spot" && marginMode == "Borrow" && (
            <>
              {/* <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2" >
                  <div>
                    Max
                  </div>
                  <div>
                    {maxMarginFirst}  {id?.split("_")[1]}
                  </div>
                </div>
              </div> */}

              <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2">
                  <div>Borrowing</div>
                  <div>
                    {orderValue &&
                    orderValue > userBalance?.second?.margin_balance
                      ? Math.abs(
                          orderValue - userBalance?.second?.margin_balance
                        )
                      : 0}{" "}
                    {id?.split("_")[1]}
                  </div>
                </div>
              </div>
            </>
          )}

          {type != "spot" && marginMode == "Repay" && (
            <>
              <div className="buy-btn mt-10 fnt-cost">
                {/* <div className="display-2">
                  <div>Repaying</div>
                  <div>0 {id?.split("_")[1]}</div>
                </div> */}
                <div className="display-2 mt-5">
                  <div>Liabilities</div>
                  {userBalance?.first?.margin_debt_amount
                    ? Number(userBalance?.first?.margin_debt_amount)?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[0]}
                </div>
              </div>
            </>
          )}
          <div className="buy-btn mt-10">
            {token ? (
              <Button
                variant="contained"
                disabled={statusLoad}
                onClick={() => {
                  if (token) {
                    placeOrderSubmit("BUY");
                  }
                }}
              >
                Buy
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")}>
                {" "}
                Login / Sign Up
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const stopLimitSell = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="display-1">
              <div className="aval aval-balance">Available balance</div>
              {type === "cross" && (
                <div
                  onClick={() => setOpen1(true)}
                  className="aval leaverage-tab cursor"
                >
                  {crossLev}x
                </div>
              )}
            </div>
            <div className="display-1 usd">
              {/* <div className="">{userBalance?.first != null ? Number(userBalance?.first?.spot_balance)?.toFixed(4) : 0} {id?.split("_")[0]}</div> */}
              {type === "spot" && (
                <div className="">
                  {firstBalance ? firstBalance : 0} {id?.split("_")[0]}
                </div>
              )}
              {type === "cross" &&
              (marginMode === "Normal" || marginMode === "Repay") ? (
                <div className="">
                  {" "}
                  {userBalance?.first?.margin_balance
                    ? Number(userBalance?.first?.margin_balance)?.toFixed(8)
                    : 0}{" "}
                  {id?.split("_")[0]}
                </div>
              ) : (
                type === "cross" &&
                marginMode === "Borrow" && (
                  <div className="">
                    {" "}
                    {firstBalance ? firstBalance : 0} {id?.split("_")[0]}
                  </div>
                )
              )}
            </div>
          </div>
          {/* <div className="trade-label">Order price</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field mt-5"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Stop"
              type="number"
              value={stopPrice}
              onChange={(e) => {
                setStopPrice(e.target.value);
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Qty</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Price"
              type="number"
              value={price}
              onChange={(e) => {
                // priceChange(e.target.value, "");
                const input = e.target.value;
                // Build dynamic regex for decimal places
                const regex = new RegExp(`^\\d*(\\.\\d{0,${basePrecision}})?$`);

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange(numericValue, "");
                  setPrice(numericValue);
                  if (numericValue) {
                    if (quantity) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(quantity || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          basePrecision
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Order value</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[0]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Amount"
              type="number"
              value={quantity}
              onChange={(e) => {
                // priceChange("", e.target.value);
                const input = e.target.value;
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);
                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  // priceChange("", numericValue);
                  setQuantity(numericValue);
                  if (numericValue) {
                    if (price) {
                      setOrderValue(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) *
                            parseFloat(price || 0),
                          pointFilter
                        )
                      );
                    } else if (orderValue) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(orderValue || 0) /
                            parseFloat(numericValue || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setOrderValue("");
                  }
                }
              }}
            />
          </FormControl>

          {/* <div class="mydict">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
              setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "SELL");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div> */}
          <div className="display-2 flex-wrap">
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(25, "", "SELL")}
            >
              25%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(50, "", "SELL")}
            >
              50%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(75, "", "SELL")}
            >
              75%
            </div>
            <div
              className="new-perc-div"
              onClick={() => priceChangeSlider(100, "", "SELL")}
            >
              100%
            </div>
          </div>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Amount"
              type="number"
              value={orderValue}
              onChange={(e) => {
                // priceChangeSlider("", e.target.value, "BUY");
                const input = e.target.value;
                const regex = new RegExp(`^\\d*(\\.\\d{0,${pointFilter}})?$`);
                if (regex.test(input)) {
                  const numericValue = parseFloat(input);
                  setOrderValue(numericValue);
                  // priceChangeSlider("", numericValue, "BUY");
                  if (numericValue) {
                    if (price) {
                      setQuantity(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(price || 1),
                          basePrecision
                        )
                      );
                    } else if (quantity) {
                      setPrice(
                        formatWithPrecisionLimit(
                          parseFloat(numericValue || 0) /
                            parseFloat(quantity || 1),
                          pointFilter
                        )
                      );
                    }
                  } else {
                    setQuantity("");
                  }
                }
              }}
            />
          </FormControl>

          {type != "spot" && marginMode == "Borrow" && (
            <>
              {/* <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2" >
                  <div>
                    Max
                  </div>
                  <div>
                    {maxMarginFirst}  {id?.split("_")[1]}
                  </div>
                </div>
              </div> */}

              <div className="buy-btn mt-10 fnt-cost">
                <div className="display-2">
                  <div>Borrowing</div>
                  <div>
                    {quantity && quantity > userBalance?.first?.margin_balance
                      ? Math.abs(quantity - userBalance?.first?.margin_balance)
                      : 0}{" "}
                    {id?.split("_")[0]}
                  </div>
                </div>
              </div>
            </>
          )}

          {type != "spot" && marginMode == "Repay" && (
            <>
              <div className="buy-btn mt-10 fnt-cost">
                {/* <div className="display-2">
                  <div>Repaying</div>
                  <div>0 {id?.split("_")[1]}</div>
                </div> */}
                <div className="display-2 mt-5">
                  <div>Liabilities</div>
                  {userBalance?.second?.margin_debt_amount
                    ? Number(userBalance?.second?.margin_debt_amount)?.toFixed(
                        8
                      )
                    : 0}{" "}
                  {id?.split("_")[1]}
                </div>
              </div>
            </>
          )}
          <div className="sell-btn mt-10">
            {token ? (
              <Button
                variant="contained"
                disabled={statusLoad}
                onClick={() => {
                  if (token) {
                    placeOrderSubmit("SELL");
                  }
                }}
              >
                Sell
              </Button>
            ) : (
              <Button onClick={() => navigate("/login")}>
                {" "}
                Login / Sign Up
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const limitFuture = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="aval aval-balance">Available balance</div>
            <div className="display-1 usd">
              <div className="">
                {" "}
                {/* {userBalance?.second != null
                  ? Number(userBalance?.second?.spot_balance)?.toFixed(4)
                  : 0}{" "} */}
                {secondBalance} {id?.split("_")[1]}
              </div>
            </div>
          </div>
          {/* <div className="trade-label">Order price</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field mt-5"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Order Price"
              type="number"
              value={futurePrice}
              onChange={(e) => {
                setFuturePrice(e.target.value);
                // setPrice(e.target.value)
                openCostCalculation(e.target.value, "");
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Qty</div> */}
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[0]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Size"
              type="number"
              value={futureQuantity}
              onChange={(e) => {
                const input = e.target.value;
                const regex = /^\d*(\.\d{0,6})?$/; // up to 6 decimal places

                // Allow empty input without error
                if (input === "") {
                  setFutureQuantity("");
                  setMultiplierError(""); // clear error silently
                  return;
                }

                if (regex.test(input)) {
                  const numericValue = parseFloat(input);

                  const isMultiple =
                    Number.isFinite(numericValue) &&
                    Math.abs(
                      numericValue -
                        Math.round(numericValue / multiplier) * multiplier
                    ) < 1e-8;
                  setFutureQuantity(numericValue);
                  openCostCalculation("", numericValue);
                  if (isMultiple) {
                    setMultiplierError(""); // clear error
                  } else {
                    setMultiplierError(
                      `Value must be a multiple of ${multiplier}`
                    );
                  }
                }
              }}
            />
            {multiplierError && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  backgroundColor: "#f44336",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  marginTop: "4px",
                  whiteSpace: "nowrap",
                  zIndex: 10,
                }}
              >
                {multiplierError}
              </div>
            )}
          </FormControl>
          {/* <div className="trade-label">Order value</div> */}

          <div class="mydict">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
                setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "BUY");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div>
          <div className="">
            {position == "Open" ? (
              <>
                {token ? (
                  <div className="display-2 flex-wrap ">
                    <div className="buy-btn mt-10">
                      <Button
                        variant="contained"
                        disabled={
                          statusLoad || (multiplierError == "" ? false : true)
                        }
                        onClick={() => {
                          if (token) {
                            PlaceFutureOrder("BUY", "LONG");
                          }
                        }}
                      >
                        Open Long
                      </Button>
                      {/* <div className="buy-btn mt-10 fnt-cost">
                        <div className="display-2 cost" >
                          <div>
                            {openLongCost} {id?.split("_")[1]}
                          </div>
                        </div>
                      </div> */}
                      <div className="buy-btn mt-10 fnt-cost">
                        <div className="display-2 cost">
                          <div>Cost</div>
                          <div>
                            {openLongCost} {id?.split("_")[1]}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="sell-btn mt-10">
                      <Button
                        variant="contained"
                        disabled={
                          statusLoad || (multiplierError == "" ? false : true)
                        }
                        onClick={() => {
                          if (token) {
                            PlaceFutureOrder("SELL", "SHORT");
                          }
                        }}
                      >
                        Open Short
                      </Button>
                      {/* <div className="buy-btn mt-10 fnt-cost">
                        <div className="display-2 cost" >
                          <div>
                            {openLongCost} {id?.split("_")[1]}
                          </div>
                        </div>
                      </div> */}
                      <div className="sell-btn mt-10 fnt-cost">
                        <div className="display-2">
                          <div>Cost</div>
                          <div>
                            {openShortCost} {id?.split("_")[1]}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="display-3 my-20">
                    <div className="login-deposit-btn">
                      <Button
                        variant="contained"
                        onClick={() => navigate("/login")}
                      >
                        {" "}
                        Login / Sign Up
                      </Button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="buy-btn mt-10">
                  <Button
                    variant="contained"
                    disabled={statusLoad}
                    onClick={() => {
                      if (token) {
                        PlaceFutureOrder("BUY", "SHORT");
                      }
                    }}
                  >
                    Close Short
                  </Button>
                </div>
                <div className="sell-btn mt-10">
                  <Button
                    variant="contained"
                    disabled={statusLoad}
                    onClick={() => {
                      if (token) {
                        PlaceFutureOrder("SELL", "LONG");
                      }
                    }}
                  >
                    Close Long
                  </Button>
                </div>
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const marketFuture = (
    <>
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="display-2">
            <div className="aval aval-balance">Available balance</div>
            <div className="display-1 usd">
              <div className="">
                {" "}
                {/* {userBalance?.second != null
                  ? Number(userBalance?.second?.spot_balance)?.toFixed(4)
                  : 0}{" "} */}
                {secondBalance} {id?.split("_")[1]}
              </div>
            </div>
          </div>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            className="price-field"
          >
            <OutlinedInput
              id="outlined-adornment-weight"
              endAdornment={
                <InputAdornment position="end" className="adroment">
                  {id?.split("_")[1]}
                </InputAdornment>
              }
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              placeholder="Size"
              type="number"
              value={futureQuantity}
              onChange={(e) => {
                setFutureQuantity(e.target.value);
              }}
            />
          </FormControl>
          {/* <div className="trade-label">Order value</div> */}

          <div class="mydict ">
            <Slider
              aria-label="Temperature"
              value={sliderValue}
              getAriaValueText={valuetext}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={25}
              marks
              min={0}
              max={100}
              onChange={(e) => {
                setSliderValue(e.target.value);
                priceChangeSlider(e.target.value, "", "BUY");
              }}
            />
            <div className="display-2">
              <p>0</p>
              <p>100%</p>
            </div>
          </div>
          <div className="display-2">
            {position == "Open" ? (
              <>
                <div className="buy-btn mt-10">
                  <Button
                    variant="contained"
                    disabled={statusLoad}
                    onClick={() => {
                      if (token) {
                        PlaceFutureOrder("BUY", "LONG");
                      }
                    }}
                  >
                    Open Long
                  </Button>
                  <div className="buy-btn mt-10 fnt-cost">
                    <div className="display-2 cost">
                      <div>Cost</div>
                      <div>
                        {marketOpenLongCost} {id?.split("_")[1]}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sell-btn mt-10">
                  <Button
                    variant="contained"
                    disabled={statusLoad}
                    onClick={() => {
                      if (token) {
                        PlaceFutureOrder("SELL", "SHORT");
                      }
                    }}
                  >
                    Open Short
                  </Button>
                  <div className="sell-btn mt-10 fnt-cost">
                    <div className="display-2">
                      <div>Cost</div>
                      <div>
                        {marketOpenShortCost} {id?.split("_")[1]}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="buy-btn mt-10">
                  <Button
                    variant="contained"
                    disabled={statusLoad}
                    onClick={() => {
                      if (token) {
                        PlaceFutureOrder("BUY", "SHORT");
                      }
                    }}
                  >
                    Close Short
                  </Button>
                </div>
                <div className="sell-btn mt-10">
                  <Button
                    variant="contained"
                    disabled={statusLoad}
                    onClick={() => {
                      if (token) {
                        PlaceFutureOrder("SELL", "LONG");
                      }
                    }}
                  >
                    Close Long
                  </Button>
                </div>
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );

  const placeOrder = (
    <>
      {/* {!mobilemd && (
        <Box>
          <div className="text-right" style={{ padding: "0 !important" }}>
            <HighlightOffIcon
              sx={{ fill: "var(--clr-font)", cursor: "pointer" }}
              onClick={() => {
                setState({ bottom: false });
              }}
            />
          </div>
        </Box>
      )} */}
      <CustomTabPanel value={value2} index={0}>
        <Grid container>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box sx={{ width: "100%", padding: "0 !important" }}>
              {!screen && (
                <Box sx={{ padding: "0 !important" }}>
                  <Tabs
                    value={value3}
                    onChange={handleChange3}
                    aria-label="basic tabs example"
                    className="buy-sell-tabs"
                  >
                    <Tab label="Buy" {...a11yProps(0)} className="buy" />
                    <Tab label="Sell" {...a11yProps(1)} className="sell" />
                  </Tabs>
                </Box>
              )}
              <CustomTabPanel value={value3} index={0}>
                <Box>
                  <Tabs
                    value={value4}
                    onChange={handleChange4}
                    aria-label="basic tabs example"
                    className="tabs-trade limit-market-tab"
                  >
                    <Tab label="Limit" {...a11yProps(0)} />
                    <Tab label="Market" {...a11yProps(1)} />
                    <Tab label="Spot Limit" {...a11yProps(2)} />
                  </Tabs>
                </Box>
                <CustomTabPanel value={value4} index={0}>
                  {screen ? (
                    <div className="display-2 flex-end gap">
                      {limitBuy}
                      {limitSell}
                    </div>
                  ) : (
                    limitBuy
                  )}
                </CustomTabPanel>
                <CustomTabPanel value={value4} index={1}>
                  {screen ? (
                    <div className="display-2 flex-end gap">
                      {marketBuy}
                      {marketSell}
                    </div>
                  ) : (
                    marketBuy
                  )}
                </CustomTabPanel>
                <CustomTabPanel value={value4} index={2}>
                  {screen ? (
                    <div className="display-2 flex-end gap">
                      {stopLimitBuy}
                      {stopLimitSell}
                    </div>
                  ) : (
                    stopLimitBuy
                  )}
                </CustomTabPanel>
              </CustomTabPanel>
              <CustomTabPanel value={value3} index={1}>
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box sx={{ width: "100%" }}>
                      <Box>
                        <Tabs
                          value={value4}
                          onChange={handleChange4}
                          aria-label="basic tabs example"
                          className="tabs-trade  limit-market-tab"
                        >
                          <Tab label="Limit" {...a11yProps(0)} />
                          <Tab label="Market" {...a11yProps(1)} />
                          <Tab label="Spot Limit" {...a11yProps(2)} />
                        </Tabs>
                      </Box>
                      <CustomTabPanel value={value4} index={0}>
                        {limitSell}
                      </CustomTabPanel>
                      <CustomTabPanel value={value4} index={1}>
                        {marketSell}
                      </CustomTabPanel>
                      <CustomTabPanel value={value4} index={2}>
                        {stopLimitSell}
                      </CustomTabPanel>
                    </Box>
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
                </Grid>
              </CustomTabPanel>
            </Box>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
        </Grid>
      </CustomTabPanel>
    </>
  );

  const placeOrderMargin = (
    <>
      <CustomTabPanel value={value2} index={0}>
        <Grid container>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box sx={{ width: "100%", padding: "0 !important" }}>
              {!screen && (
                <Box sx={{ padding: "0 !important" }}>
                  <Tabs
                    value={value3}
                    onChange={handleChange3}
                    aria-label="basic tabs example"
                    className="buy-sell-tabs"
                  >
                    <Tab label="Buy" {...a11yProps(0)} className="buy" />
                    <Tab label="Sell" {...a11yProps(1)} className="sell" />
                  </Tabs>
                </Box>
              )}
              <CustomTabPanel value={value3} index={0}>
                <Box>
                  <Tabs
                    value={value4}
                    onChange={handleChange4}
                    aria-label="basic tabs example"
                    className="tabs-trade limit-market-tab"
                  >
                    <Tab label="Limit" {...a11yProps(0)} />
                    <Tab label="Market" {...a11yProps(1)} />
                    <Tab label="Spot Limit" {...a11yProps(2)} />
                  </Tabs>
                </Box>
                <div className="crosx-opt">
                  <Button
                    style={{ fontSize: "11px" }}
                    onClick={() => {
                      setMarginMode("Normal");
                    }}
                    className={marginMode == "Normal" && "active"}
                  >
                    Normal
                  </Button>
                  <Button
                    style={{ fontSize: "11px" }}
                    onClick={() => {
                      setMarginMode("Borrow");
                    }}
                    className={marginMode == "Borrow" && "active"}
                  >
                    Borrow
                  </Button>
                  <Button
                    style={{ fontSize: "11px" }}
                    onClick={() => {
                      setMarginMode("Repay");
                    }}
                    className={marginMode == "Repay" && "active"}
                  >
                    Repay
                  </Button>
                </div>
                <CustomTabPanel value={value4} index={0}>
                  {screen ? (
                    <div className="display-2 flex-end gap">
                      {limitBuy}
                      {limitSell}
                    </div>
                  ) : (
                    limitBuy
                  )}
                </CustomTabPanel>
                <CustomTabPanel value={value4} index={1}>
                  {screen ? (
                    <div className="display-2 flex-end gap">
                      {marketBuy}
                      {marketSell}
                    </div>
                  ) : (
                    marketBuy
                  )}
                </CustomTabPanel>
                <CustomTabPanel value={value4} index={2}>
                  {screen ? (
                    <div className="display-2 flex-end gap">
                      {stopLimitBuy}
                      {stopLimitSell}
                    </div>
                  ) : (
                    stopLimitBuy
                  )}
                  {/* {stopLimitBuy} */}
                </CustomTabPanel>
              </CustomTabPanel>
              <CustomTabPanel value={value3} index={1}>
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box sx={{ width: "100%" }}>
                      <Box>
                        <Tabs
                          value={value4}
                          onChange={handleChange4}
                          aria-label="basic tabs example"
                          className="tabs-trade  limit-market-tab"
                        >
                          <Tab label="Limit" {...a11yProps(0)} />
                          <Tab label="Market" {...a11yProps(1)} />
                          <Tab label="Spot Limit" {...a11yProps(2)} />
                        </Tabs>
                      </Box>
                      <div className="crosx-opt">
                        <Button
                          style={{ fontSize: "11px" }}
                          onClick={() => {
                            setMarginMode("Normal");
                          }}
                          className={marginMode == "Normal" && "active"}
                        >
                          Normal
                        </Button>
                        <Button
                          style={{ fontSize: "11px" }}
                          onClick={() => {
                            setMarginMode("Borrow");
                          }}
                          className={marginMode == "Borrow" && "active"}
                        >
                          Borrow
                        </Button>
                        <Button
                          style={{ fontSize: "11px" }}
                          onClick={() => {
                            setMarginMode("Repay");
                          }}
                          className={marginMode == "Repay" && "active"}
                        >
                          Repay
                        </Button>
                      </div>
                      <CustomTabPanel value={value4} index={0}>
                        {limitSell}
                      </CustomTabPanel>
                      <CustomTabPanel value={value4} index={1}>
                        {marketSell}
                      </CustomTabPanel>
                      <CustomTabPanel value={value4} index={2}>
                        {stopLimitSell}
                      </CustomTabPanel>
                      {/* {console.log(marginMode, "marginModemarginMode")} */}
                    </Box>
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
                </Grid>
              </CustomTabPanel>
            </Box>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
        </Grid>
      </CustomTabPanel>
    </>
  );

  const placeOrderFuture = (
    <>
      {/* {!mobilemd && (
        <Box>
          <div className="text-right" style={{ padding: "0 !important" }}>
            <HighlightOffIcon
              sx={{ fill: "var(--clr-font)", cursor: "pointer" }}
              onClick={() => {
                setState({ bottom: false });
              }}
            />
          </div>
        </Box>
      )} */}

      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box sx={{ width: "100%", padding: "0 !important" }}>
            <div className="display-1">
              {/* <div className="future-cx" >
                Cross
              </div> */}
              <Box sx={{ minWidth: 80 }} className="cross-slct">
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    sx={{ svg: { fill: "var(--clr-bcg) !important" } }}
                    onChange={handleChange}
                  >
                    <MenuItem value={"cross"}>Cross</MenuItem>
                    {/* <MenuItem value={"isolated"}>Isolated</MenuItem> */}
                  </Select>
                </FormControl>
              </Box>
              <div className="future-cx" onClick={() => handleOpen()}>
                {leverage}X
              </div>
            </div>

            {/* <Button variant="contained" onClick={() => { setPosition("Open") }} >Open</Button>
            <Button variant="contained" onClick={() => { setPosition("Close") }} >Close</Button> */}
            <Box>
              <Tabs
                value={value4}
                onChange={handleChange4}
                aria-label="basic tabs example"
                className="tabs-trade limit-market-tab"
              >
                <Tab label="Limit" {...a11yProps(0)} />
                <Tab label="Market" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value4} index={0}>
              {/* {(classic || fullScreen) ? <div className="display-2 flex-end gap">
                    {limitBuy}
                    {limitSell}
                  </div> : limitBuy} */}
              {limitFuture}
              {}
            </CustomTabPanel>
            <CustomTabPanel value={value4} index={1}>
              {/* {(classic || fullScreen) ? <div className="display-2 flex-end gap">
                    {marketBuy}
                    {marketSell}
                  </div> : marketBuy} */}
              {marketFuture}
            </CustomTabPanel>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
      </Grid>
    </>
  );

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        padding: !mobilemd ? "15px" : "",
      }}
      role="presentation"
    >
      {placeOrder}
    </Box>
  );
  useEffect(() => {
    return localStorage.getItem("layout") === "classic" ||
      localStorage.getItem("layout") === "fullscreen"
      ? setScreen(true)
      : setScreen(false);
  }, []);

  function countDecimals(num) {
    // // Convert to string if it's a number
    // let strNum = typeof num === "number" ? num.toString() : num;

    // if (!strNum.includes(".")) return 0; // No decimal point means 0 decimals

    // // Trim trailing zeros to count only significant decimal places
    // console.log(strNum.split(".")[1].replace(/0+$/, "").length, "strNum.split")
    window.filterPoint = num;
    return num;
  }

  const getBalance = async (id) => {
    try {
      const url = `${consts.BackendUrl}/wallet/OwnWalletGetID`;
      const payload = {
        pair: id,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        var userBalance = result?.result;
        // console.log(type, "typetype")
        setFeesDetails(userBalance?.fees);
        setKucoinFeeDetails(userBalance?.originalFee);
        if (pathname?.includes("future")) {
          setSecondBalance(
            userBalance?.second != null
              ? Number(userBalance?.second?.future_balance)?.toFixed(8)
              : 0
          );
          setFirstBalance(
            userBalance?.first != null
              ? Number(userBalance?.first?.future_balance)?.toFixed(8)
              : 0
          );
        } else {
          if (type == "spot") {
            // console.log(userBalance?.second?.spot_balance, "userBalance?.second?.spot_balance");
            setUserBalance(userBalance);
            setSecondBalance(
              userBalance?.second != null
                ? Number(userBalance?.second?.spot_balance)?.toFixed(8)
                : 0
            );
            setFirstBalance(
              userBalance?.first != null
                ? Number(userBalance?.first?.spot_balance)?.toFixed(8)
                : 0
            );
          } else if (type == "cross") {
            setUserBalance(userBalance);
            setSecondBalance(
              userBalance?.second != null
                ? Number(userBalance?.second?.margin_amount)?.toFixed(8)
                : 0
            );
            setFirstBalance(
              userBalance?.first != null
                ? Number(userBalance?.first?.margin_amount)?.toFixed(8)
                : 0
            );
          }
        }
        // setUserBalance(result?.result)  point
        setBalance(result?.result);
        setPointFilter(countDecimals(userBalance?.point));
        setBasePrecision(userBalance?.base_precision);
        setQuotePrecision(userBalance?.quote_precision);
        setMultiplier(userBalance?.multiplier);
      } else {
        setUserBalance("");
        setBalance("");
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (id && token) {
      getBalance(id);
      getLeverage();
      getMarginDetails();
    }
  }, [id, balanceUpdate, type]);

  useEffect(() => {
    if (pathname?.includes("future")) {
      setValueTab3(0);
    }
  }, [pathname]);

  const changeLeverage = async (value) => {
    try {
      const url = `${consts.BackendUrl}/owntrade/updateFutureLeverage`;
      var payload = {
        pair: id,
      };
      if (age == "cross") {
        payload.cross_lever = value;
      } else {
        payload.isolated_lever = value;
      }
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        setLeverage(value);
        handleClose();
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const changeMarginType = async (value) => {
    try {
      const url = `${consts.BackendUrl}/owntrade/updateFutureLeverage`;
      var payload = {
        pair: id,
        marginmode: value,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        // console.log(result?.result?.marginMode, "result?.result?.marginMode");
        if (result?.result?.marginMode == "cross") {
          setLev(result?.result?.cross_lever);
          setLeverage(result?.result?.cross_lever);
        } else {
          setLev(result?.result?.isolated_lever);
          setLeverage(result?.result?.isolated_lever);
        }
        handleClose();
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const changeCrossLeaverage = async () => {
    try {
      const url = `${consts.BackendUrl}/ownTrade/updateLeverage`;
      const payload = {
        leverage: tempLev,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        setCrossLev(tempLev);
        setOpen1(false);
        getBalance(id);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const crossLevMarks = [
    { value: 1, label: "1x" },
    { value: 2, label: "2x" },
    { value: 3, label: "3x" },
    { value: 4, label: "4x" },
    { value: 5, label: "5x" },
  ];

  return (
    <div
      className="trade-left"
      style={{
        height: classic || fullScreen ? "auto" : "100%",
        display: "flex",
      }}
    >
      {/* <ToastContainer /> */}
      <Grid container>
        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            sx={{
              width: "100%",
              height: classic || fullScreen ? "auto" : "100%",
            }}
            className="grid-box  spot-margin-trade"
          >
            {
              <Box className="display-2">
                <Tabs
                  value={valueTab3}
                  sx={{
                    pl: classic || fullScreen ? "10px" : "5px",
                    minHeight: "30px",
                  }}
                  onChange={handleChangeTab3}
                  aria-label="basic tabs example"
                  className="spot-tab limit-market-tab"
                >
                  {!pathname?.includes("future") && (
                    <Tab label="Spot" {...a11yProps(0)} />
                  )}
                  {!pathname?.includes("future") && (
                    <Tab label="Cross" {...a11yProps(1)} />
                  )}
                  {/* {!pathname?.includes("future") && (
                    <Tab label="Isolated" {...a11yProps(2)} />
                  )} */}

                  {pathname?.includes("future") && (
                    <Tab label="Future" {...a11yProps(2)} />
                  )}

                  {/* <div  className="convert">
                                Convert</div> */}
                </Tabs>
                {/* <div className="display-2 trade-features">
                  <div className="trade-features-menu">
                    <MoreVertIcon />{" "}
                  </div>
                  <div className="trade-features-content">
                    <Link>Turn off Margin</Link>
                    <Link>Spot Trading Fees</Link>
                    <Link>Margin Specifications</Link>
                    <Link>Spot Trading Rules</Link>
                  </div>
                </div> */}
              </Box>
            }

            <CustomTabPanel value={valueTab3} index={0}>
              <Grid container>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                  {pathname?.includes("future") ? (
                    <Box>{placeOrderFuture}</Box>
                  ) : (
                    <Box>{placeOrder}</Box>
                  )}
                </Grid>
              </Grid>

              {/* {!mobilemd && (
                <AppBar
                  position="fixed"
                  color="primary"
                  sx={{ top: "auto", bottom: 0 }}
                >
                  <Toolbar sx={{ justifyContent: "space-evenly" }}>
                    {["bottom"]?.map((anchor, index) => (
                      <React.Fragment key={index}>
                        <div className="buy-h-btn display-2" style={{ width: "100%" }}>
                          <Button
                            variant="contained"
                            onClick={toggleDrawer(anchor, true, 0)}
                          >
                            {"Buy"}
                          </Button>
                        </div>

                        <Drawer
                          anchor={anchor}
                          open={state[anchor]}
                          className="drawer-bottom"
                        >
                          {list(anchor)}
                        </Drawer>
                      </React.Fragment>
                    ))}

                    {["bottom"]?.map((anchor, index) => (
                      <React.Fragment key={index}>
                        <div className="sell-h-btn display-2" style={{ width: "100%" }}>
                          <Button
                            variant="contained"
                            onClick={toggleDrawer(anchor, true, 1)}
                          >
                            {"Sell"}
                          </Button>
                        </div>

                        <Drawer
                          anchor={anchor}
                          open={state[anchor]}
                          className="drawer-bottom"
                        >
                          {list(anchor)}
                        </Drawer>
                      </React.Fragment>
                    ))}
                  </Toolbar>
                </AppBar>
              )} */}
            </CustomTabPanel>
            <CustomTabPanel value={valueTab3} index={1}>
              <Grid container>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Box>{placeOrderMargin}</Box>
                </Grid>
              </Grid>
            </CustomTabPanel>
            {pathname?.includes("future") ? (
              <CustomTabPanel value={valueTab3} index={2}>
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box>{placeOrderFuture}</Box>
                  </Grid>
                </Grid>
              </CustomTabPanel>
            ) : (
              <CustomTabPanel value={valueTab3} index={2}>
                <Grid container>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box>{placeOrderMargin}</Box>
                  </Grid>
                </Grid>
              </CustomTabPanel>
            )}
          </Box>
        </Grid>
      </Grid>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Leverage Mode
            </Typography>
            <HighlightOffIcon
              sx={{ fontSize: "25px !important" }}
              onClick={() => handleClose()}
              className="cursor"
            />
          </div>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Slider
              value={lev}
              max={maxLeverage}
              onChange={(e) => setLev(e.target.value)}
              aria-label="Default"
              valueLabelDisplay="auto"
              className="margin-slider"
            />
            <div className="display-2">
              <div>1X</div>
              <div>{maxLeverage}X</div>
            </div>
            <div className="text-center">
              <Button
                variant="contained"
                sx={{ bgcolor: "#566FFF !important" }}
                onClick={() => {
                  if (token) {
                    changeLeverage(lev);
                  }
                }}
              >
                Apply
              </Button>
            </div>
          </Typography>
        </Box>
      </Modal>
      <Modal
        open={open1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Set Leverage
            </Typography>
            <HighlightOffIcon
              sx={{ fontSize: "25px !important" }}
              onClick={() => setOpen1(false)}
              className="cursor"
            />
          </div>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Slider
              sx={{
                "& .MuiSlider-markLabel": {
                  color: "var(--clr-font)",
                  fontWeight: "bold",
                  fontSize: "0.85rem",
                },
              }}
              value={tempLev}
              marks={crossLevMarks}
              min={1}
              max={5}
              step={1}
              onChange={(e) => setTempLev(e.target.value)}
              aria-label="Custom marks"
              valueLabelDisplay="auto"
              className="margin-slider"
            />
            {/* <div className="cross-lev-card">
              You can borrow up to <span className="highlight-text">{maxMarginFirst} {id?.split("_")[0]}</span> or <span className="highlight-text">{maxMarginSecond} {id?.split("_")[1]}</span> under the current leaverage.
            </div> */}
            <div className="text-center">
              <Button
                variant="contained"
                sx={{ bgcolor: "#566FFF !important" }}
                onClick={() => {
                  if (token) {
                    changeCrossLeaverage();
                  }
                }}
              >
                Apply
              </Button>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}

export default TradeRight;
